import { clientFetch } from "./clientFetch";

// Example: Specific service for events
export const UserService = {
  getAllUsers: (uidCompany:string) => 
    clientFetch(`/v1/users/${uidCompany}`,'GET'),
  getUsersByIds: (uidCompany:string,uids:string[],key:string) => 
    clientFetch(`/v1/users`,'POST',key,{ body:{company:uidCompany,users:uids}}),
  searchBulkUsers: (search: string, company: string, key: string) =>
    clientFetch('/v1/users/search', 'POST', key, { body: { company, search } }),
};
